import PropTypes from 'prop-types';
import { Anchor } from '@zillow/constellation';

export default function BodySectionAnchor({ anchor }) {
  return (
    <Anchor
      {...{
        href: anchor.href,
        target: '_blank',
      }}
    >
      {anchor.text}
    </Anchor>
  );
}

BodySectionAnchor.propTypes = {
  anchor: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};
